export * from './honorar-vereinbarungen.component';
export * from './honorar-vereinbarungen.component.module';